(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define(
      'product-modal',
      class ProductModal extends ModalDialog {
        constructor() {
          super();
        }
        hide() {
          super.hide();
          window.pauseAllMedia();
        }
        show(opener) {
          super.show(opener);
          this.showActiveMedia();
					const lazyImages = this.querySelectorAll('.lazy-image');
					if(lazyImages.length > 0) {
						lazyImages.forEach(img => {
							this.loadImage(img)
							img.classList.remove('lazy-image');
						});
					}
        }

				loadImage = (img) => {
					img.src = img.dataset.src;
					img.srcset = img.dataset.srcset;
					img.sizes = img.dataset.sizes;
					img.classList.remove('lazy-image');
				}

        showActiveMedia() {
          this.querySelectorAll(
            `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
          ).forEach((element) => {
            element.classList.remove('active');
          });
          const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          )
            activeMedia.loadContent();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	if (!customElements.get('cart-note')) {
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('change', debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
				}, 300))
			}
		}

		customElements.define('cart-note', CartNote);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	if (!customElements.get('cart-note')) {
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					'change',
					debounce((event) => {
						const body = JSON.stringify({ note: event.target.value });
						fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
					}, 300)
				);
			}
		}

		customElements.define('cart-note', CartNote);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-modal')) {
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
				const lazyImages = this.querySelectorAll('.lazy-image');
				if(lazyImages.length > 0) {
					lazyImages.forEach(img => {
						this.loadImage(img)
						img.classList.remove('lazy-image');
					});
				}
      }

			loadImage = (img) => {
				img.src = img.dataset.src;
				img.srcset = img.dataset.srcset;
				img.sizes = img.dataset.sizes;
				img.classList.remove('lazy-image');
			}

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }

    customElements.define('product-modal', ProductModal);
  }

  /*
   * Quantity stepper — minus / typable number / plus.
   *
   * Deliberately self-contained: it does NOT extend the theme's QuantityInput,
   * whose connectedCallback calls subscribe(PUB_SUB_EVENTS.quantityUpdate) and
   * therefore needs pubsub.js, and whose validateQtyRules() dereferences
   * .quantity__button elements without a null check.
   *
   * Maximum comes from the per-variant stock map rendered next to the input.
   * A null entry (untracked inventory, or "continue selling when out of stock")
   * means no maximum at all.
   */
  if (!customElements.get('quantity-stepper')) {
    class QuantityStepper extends HTMLElement {
      constructor() {
        super();

        this.input = this.querySelector('input[name="quantity"]');
        this.minusButton = this.querySelector('button[name="minus"]');
        this.plusButton = this.querySelector('button[name="plus"]');

        if (!this.input || !this.minusButton || !this.plusButton) return;

        this.min = parseInt(this.input.min, 10) || 1;
        this.step = parseInt(this.input.step, 10) || 1;
        this.rules = this.readRules();

        this.minusButton.addEventListener('click', () => this.stepBy(-this.step));
        this.plusButton.addEventListener('click', () => this.stepBy(this.step));

        this.input.addEventListener('change', () => this.normalise());
        this.input.addEventListener('blur', () => this.normalise());
        this.input.addEventListener('keydown', (event) => {
          // Enter inside the field would otherwise submit the add-to-cart form.
          if (event.key === 'Enter') {
            event.preventDefault();
            this.input.blur();
          }
        });

        this.watchVariant();
        this.applyMax();
      }

      readRules() {
        const holder = this.querySelector('script[type="application/json"]');
        if (!holder) return null;

        try {
          return JSON.parse(holder.textContent);
        } catch (error) {
          return null;
        }
      }

      // The theme's updateVariantInput() sets the hidden id field and fires a
      // bubbling change on it, so that field is the reliable variant-change hook
      // in this theme (VariantSelects here publishes no events of its own).
      watchVariant() {
        const form = this.input.form || document.getElementById(this.input.getAttribute('form'));
        this.variantInput = form ? form.querySelector('input[name="id"]') : null;
        if (!this.variantInput) return;

        this.variantInput.addEventListener('change', () => this.applyMax());
      }

      currentMax() {
        if (!this.rules || !this.variantInput) return null;

        const value = this.rules[this.variantInput.value];
        if (value === null || value === undefined) return null;

        const max = parseInt(value, 10);
        // A max below the minimum (sold out) is not a usable bound — the add
        // button is already disabled in that case.
        if (!Number.isFinite(max) || max < this.min) return null;

        return max;
      }

      applyMax() {
        const max = this.currentMax();

        if (max === null) {
          this.input.removeAttribute('max');
        } else {
          this.input.max = max;
        }

        this.normalise();
      }

      normalise() {
        const max = this.currentMax();
        let value = parseInt(this.input.value, 10);

        if (!Number.isFinite(value)) value = this.min;
        if (value < this.min) value = this.min;
        if (max !== null && value > max) value = max;

        this.input.value = value;
        this.minusButton.disabled = value <= this.min;
        this.plusButton.disabled = max !== null && value >= max;
      }

      stepBy(delta) {
        const current = parseInt(this.input.value, 10);
        this.input.value = (Number.isFinite(current) ? current : this.min) + delta;

        this.normalise();
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    customElements.define('quantity-stepper', QuantityStepper);
  }

  } catch(e) { console.error(e); }
})();
})();
